<ng-container>
    <div *ngIf="!isApiError && !isPending">
        <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
        </div>
        <h1 mat-dialog-title>{{ addAdditionalData.header }}</h1>
        <div class="flex-container" *ngIf="!isSuccess && !isPending && currentStatus === ProgressStatus.SUMMARY">
            <div class="feature-content">
                <p class="description">{{ addAdditionalData.subhead }}</p>
                <div class="feature-list" *ngFor="let feature of features">
                    <xm-media-image [imageOptions]="feature.imageOption" size="height" class="icons"></xm-media-image>
                    <div class="feature-details">
                        <cms-text class="feature-description" [originalText]="feature.description"></cms-text>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isSuccess && !isPending && currentStatus !== ProgressStatus.SUMMARY" class="loader-section">
            <span class="loader-header">{{ loaderData.addDataHeader }}</span>
            <div class="loader">
                <div class="addon-loader-percentage">{{ addonsPollingPercentage$ | async }}%</div>
                <div class="addon-loader-bar">
                    <div class="addon-loader-bar-fill" [style.width.%]="addonsPollingPercentage$ | async"></div>
                </div>
            </div>
            <div class="addon-loader-description">{{ loaderData.description }}</div>
        </div>
        <div *ngIf="isSuccess" class="loader-section">
            <span class="loader-header">{{ loaderData.header }}</span>
            <div class="loader">
                <div class="addon-loader-percentage">{{ addonsPollingPercentage$ | async }}%</div>
                <div class="addon-loader-bar">
                    <div class="addon-loader-bar-fill" [style.width.%]="addonsPollingPercentage$ | async"></div>
                </div>
            </div>
            <div class="addon-loader-description">{{ loaderData.addDataDescription }}</div>
            <div class="action" *ngIf="loaderData.cta">
                <button class="xm-btn-primary-light" (click)="onDoneClick()"> {{ loaderData.cta }} </button>
            </div>
        </div>
        <div class="button">
            <button *ngIf="!isSuccess && currentStatus === ProgressStatus.SUMMARY" [promiseBtn]="submitPromise"
                class="xm-btn-primary-light promise-btn" (click)="submit()"><span>{{ addAdditionalData.addCTA
                    }}</span></button>
        </div>
    </div>

    <div *ngIf="!isApiError && isPending" class="pending-section">
        <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
        </div>
        <h1 mat-dialog-title>{{ addAdditionalData.header }}</h1>
        <span class="pending-header">{{ loaderData.header }}</span>
        <div class="addon-loader-description pending">{{ loaderData.description }}</div>
        <div class="pending-disclaimer">
            <xm-media-image aria-hidden="true" class="email-icon" size="height"
                [imageOptions]="emailIcon"></xm-media-image>
            <cms-text class="disc-text" [originalText]="loaderData.disclaimer"></cms-text>
        </div>
        <div class="action" *ngIf="loaderData.cta">
            <button class="xm-btn-primary-light" (click)="onDoneClick()"> {{ loaderData.cta }} </button>
        </div>
    </div>

    <div *ngIf="isApiError" class="failed-section">
        <xm-modal-close xmEscKey (escKeyPressed)="close()" (onClose)="close()"></xm-modal-close>
        <div class="image-primary">
            <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
        </div>
        <h1 mat-dialog-title>{{ addAdditionalData.header }}</h1>
        <div class="flex-container">
            <div class="feature-content">
                <p class="failed-header">{{ addAdditionalData.failedHeader }}</p>
                <div class="image-primary">
                    <xm-media-image [imageOptions]="failureIcon" size="width"></xm-media-image>
                </div>
                <cms-text [originalText]="addAdditionalData.failedDescription" class="failed-description"></cms-text>
            </div>
        </div>
    </div>
</ng-container>
